import { render, staticRenderFns } from "./FormPeriodeAvisImpot.vue?vue&type=template&id=dbaf0306"
import script from "./FormPeriodeAvisImpot.vue?vue&type=script&lang=js"
export * from "./FormPeriodeAvisImpot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports